import createComponent from 'styles/fela/createComponent';
import { Box } from 'components';
import { withBasePadding } from 'styles/fela/mixins';

export const Container = createComponent(() => ({
  extend: [
    withBasePadding(),
  ],
}), Box, []);
